$eve_app_page_design $eve_page
	title \Design
	Head null
	body /
		<= Content $eve_text
			content \Design page - Coming soon...
